import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { Subscription } from "rxjs";
import { audit, auditTime, distinctUntilChanged } from "rxjs/operators";
import * as fromApp from "../../../store/app.reducer";
import * as _ from "lodash";
import { Store } from "@ngrx/store";
import * as OrdersActions from "../../../orders/store/orders.actions";
@Component({
  selector: "app-paypal-modal",
  templateUrl: "./paypal-modal.component.html",
  styleUrls: ["./paypal-modal.component.scss"],
})
export class PaypalModalComponent implements OnInit, OnDestroy {
  @Input() paypal_iframe;
  private paypalModalIsOpen: boolean = true;
  private subscription: Subscription;
  private unsubscribeBackEvent: Subscription;

  constructor(
    private modalCtrl: ModalController,
    private store: Store<fromApp.AppState>,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );
    const el: any = document.querySelector(".paymentModal");
    el.style.setProperty("--paymentModalWidth", "340px");
    el.style.setProperty("--paymentModalHeight", "360px");

    this.store.dispatch(new OrdersActions.SetPaypalPopupOpen(true));
    this.subscription = this.store
      .select("orders")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(this.paypalModalIsOpen, state.paypalPopupOpen)
        ) {
          this.paypalModalIsOpen = _.cloneDeep(state.paypalPopupOpen);
          if (!this.paypalModalIsOpen) {
            this.closeModal();
          }
        }
      });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  ngOnDestroy() {
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
